module.exports = __webpack_public_path__ + "static/media/image-card-2.994bd4d8.png";